mutation ShareEmail($payload: ShareEmailInput!) {
    shareEmail(input: $payload) {
        email {
            id
        }
    }
}
